/* EazyBiz Solution – Theme JS */
(function () {
  'use strict';

  /* ── Sticky Header ── */
  const header = document.getElementById('eb-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('eb-header--scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── Mobile Nav Toggle ── */
  const hamburger = document.querySelector('.eb-hamburger');
  const mobileNav = document.getElementById('eb-mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const expanded = hamburger.getAttribute('aria-expanded') === 'true';
      hamburger.setAttribute('aria-expanded', String(!expanded));
      hamburger.classList.toggle('eb-hamburger--open');
      mobileNav.classList.toggle('eb-mobile-nav--open');
      mobileNav.setAttribute('aria-hidden', String(expanded));
    });

    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.classList.remove('eb-hamburger--open');
        mobileNav.classList.remove('eb-mobile-nav--open');
        mobileNav.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ── Smooth scroll for anchor links ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Scroll reveal ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('eb-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.eb-card, .eb-stat, .eb-stats__item, .eb-testimonial').forEach(el => {
      el.classList.add('eb-reveal');
      observer.observe(el);
    });
  }

  /* ── Chart bar animation ── */
  const bars = document.querySelectorAll('.eb-chart__bar');
  if (bars.length && 'IntersectionObserver' in window) {
    const chartObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          bars.forEach((bar, i) => {
            setTimeout(() => bar.classList.add('eb-chart__bar--animated'), i * 60);
          });
          chartObs.disconnect();
        }
      });
    }, { threshold: 0.5 });
    if (bars[0].closest('.eb-dashboard')) {
      chartObs.observe(bars[0].closest('.eb-dashboard'));
    }
  }
})();
